"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatToCurrency = void 0;
var _number = require("../type-checks/number");
/**
 * Tests argument to see if it is an Array object
 *
 * @name formatToCurrency
 * @param {number} Value to convert to formatted currency string
 * @returns {string} Currency String, with dollar sign and commas
 */

const formatToCurrency = value => {
  const reFormat = /(\d+)(\d{3})/;
  let amount,
    dollars,
    cents,
    result = "$0.00";
  if ((0, _number.isNumber)(value)) {
    amount = Math.round(value * 100).toString();
    dollars = amount.substring(0, amount.length - 2);
    cents = amount.substring(amount.length - 2);

    // Iterate until the pattern matching fails;
    while (reFormat.test(dollars)) {
      // Set return to itself, adding comma between matching groups;
      dollars = dollars.replace(reFormat, `${RegExp.$1},${RegExp.$2}`);
    }
    result = `$${dollars}.${cents}`;
  }
  return result;
};
exports.formatToCurrency = formatToCurrency;